import { IRouteConfig } from 'helpers/route-config';
import { createElement } from 'react';

import UserApprovalsDashboardPending from "components/portal/userApprovals/UserApprovalsDashboardPending";

// Pages
const userApprovalsPath = "/userapprovals";

export const dashboardPending = 'pending';

const userApprovalsPendingPath = `${ userApprovalsPath }/${ dashboardPending }`;

// Routes
// Permission is intentionally left undefined so the dashboard is reachable for
// any signed-in user. Add a permission string here (and on the nav tile/sidebar)
// once a dedicated "user approvals" permission exists.
export const userApprovalsRoute = {
    breadCrumb: "User Approvals",
    path: userApprovalsPath,
    element: createElement(UserApprovalsDashboardPending),
} as IRouteConfig;

export const userApprovalsPendingPathRoute = {
    breadCrumb: "Pending",
    path: userApprovalsPendingPath,
    element: createElement(UserApprovalsDashboardPending),
} as IRouteConfig;
